import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Auth from '@aws-amplify/auth';
import atatus from 'atatus';
import useGTM from 'hooks/useGTM';
import { tagForm } from 'tagManager';

import { AppRoutes } from 'routes';

import useFormFields from '../../hooks/useFormFields';
import useLocalization from '../../hooks/useLocalization';
import scrollTo from '../../utils/scrollTo';
import ErrorView from '../errors/ErrorView';
import registrationErrors from '../errors/registrationErrors';
import VerificationCodeInput from '../inputs/VerificationCode';
import OverlaySpinner from '../spinner/OverlaySpinner';
import { PrimaryButtonSto } from '../sto';

import AccountCreatedModal from './AccountCreatedModal';
function ValidateUserAccount(props) {
    const { localizedPush } = useLocalization();
    const { stepChange } = useGTM();
    const { formFields, setFormField } = useFormFields({
        verificationCode: '',
    });
    const { verificationCode } = formFields;

    const [isFormValid, setFormValidity] = useState(false);
    const [displayModal, updateModalVisibility] = useState(false);
    const [error, setError] = useState(null);
    const [isValidatingUser, setIsValidatingUser] = useState(false);

    useEffect(() => {
        setFormValidity(verificationCode.isValid);
    }, [verificationCode]);

    const onVerificationCodeChange = (input) => {
        setFormField('verificationCode', input);
    };

    const onModalClosing = () => {
        updateModalVisibility(true);
        localizedPush(AppRoutes.baseRoute);
    };

    const handleSubmitClick = async (event) => {
        event.preventDefault();
        scrollTo(0, 0);
        setError(null);
        if (isFormValid) {
            setIsValidatingUser(true);
            atatus.startTransaction('Registration-Step-3-Account-Verification-OTP');
            try {
                await Auth.confirmSignUp(props.username, verificationCode.value);
                atatus.endTransaction('Registration-Step-3-Account-Verification-OTP');
                tagForm({
                    fields: { verification_code: verificationCode.value },
                    name: 'registration-step-3',
                    success: true,
                });
                updateModalVisibility(true);
                stepChange({
                    currentPageName: 'registrationConfirmation',
                    previousPageName: 'registrationStep3',
                });
            } catch (e) {
                const errorMessage = registrationErrors[e.code];
                setError(errorMessage || 'general.unexpectedErrorOccurred');
                atatus.failTransaction('Registration-Step-3-Account-Verification-OTP');
                tagForm({
                    fields: { verification_code: verificationCode.value },
                    message: e.message,
                    name: 'registration-step-3',
                    success: false,
                });
            } finally {
                setIsValidatingUser(false);
            }
        }
    };

    return (
        <React.Fragment>
            <ErrorView error={error} />
            {isValidatingUser && <OverlaySpinner />}
            <form onSubmit={handleSubmitClick}>
                <h3 className="validationMessage">
                    <FormattedMessage id="pages.forgotPassword.subTitle" values={{ email: props.email }} />
                </h3>
                <VerificationCodeInput
                    field={verificationCode}
                    onBlur={onVerificationCodeChange}
                    onChange={onVerificationCodeChange}
                />
                <div>
                    <AccountCreatedModal onOk={onModalClosing} visible={displayModal} />
                </div>
                <div>
                    <div className="wrapper-button-sto-container continue-button">
                        <PrimaryButtonSto disabled={!isFormValid} labelKey="pages.button.continue" type="submit" />
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
}

ValidateUserAccount.propTypes = {};

export default ValidateUserAccount;
